//Menu
let category_btn_cls = document.querySelector(".category-btn-cls");
let nav = document.querySelector(".only-mobile-menu .main-navigation");
let hamMenu = document.querySelector(".main-navigation.hamburger-menu");
let hamicon = document.querySelector(".hamicon");
let search_menu = document.querySelector(".search-menu");
const mq = window.matchMedia("(max-width: 960px)");

//Ham Menu
if (hamMenu) {
  hamMenu.style.display = "none";
}

let primaryMenu = Array.prototype.slice.call(
  document.querySelectorAll(".primary-menu")
);

mq.onchange = (e) => {
  if (mq.matches) {
    if (nav) {
      nav.style.display = "none";
    }
    if (hamicon) {
      hamicon.style.display = "block";
    }
    if (document.querySelector(".mobile-menu-icon")) {
      document.querySelector(".mobile-menu-icon").style.display = "block";
    }
  } else {
    if (nav) {
      nav.style.display = "block";
    }
    if (hamicon) {
      hamicon.style.display = "none";
    }
    if (document.querySelector(".mobile-menu-icon")) {
      document.querySelector(".mobile-menu-icon").style.display = "none";
    }

    primaryMenu.forEach((menu) => {
      menu.style.height = "auto";
    });
  }
};
mq.onchange();

let openMobileNav = (e) => {
  hamicon.classList.toggle("is-active");
  if (nav) {
    if (nav.classList.contains("active")) {
      nav.style.transition = "opacity .3s ease";
      nav.style.opacity = "0";
      category_btn_cls.style.display = "block";
      search_menu.style.display = "block";
      setTimeout(function () {
        nav.classList.remove("active");
      }, 300);
    } else {
      // nav.style.transition = "opacity .3s ease";
      nav.style.opacity = "1";
      // setTimeout(function(){
      nav.classList.add("active");
      category_btn_cls.style.display = "none";
      search_menu.style.display = "none";
      // },100);
    }
  }
  document.getElementById("content").classList.toggle("filterblur");
  document.getElementById("overlay").classList.toggle("active");
  document.getElementsByTagName("BODY")[0].classList.toggle("no-scroll");
  if (nav) {
    nav.focus();
  }

  let menuLabel = document.querySelector(".mobile-menu-label");
  let menuParentList = primaryMenu[1];

  if (
    document.querySelector(".menu-with-cta").children.length == 0 ||
    document.querySelector(".menu-with-cta .ham-menu")
  ) {
    menuParentList = primaryMenu[0];
  }

  let menuFromTop = menuParentList.getBoundingClientRect().top;

  menuParentList.classList.toggle("active-submenu");

  if (menuLabel) {
    if (nav.classList.contains("active")) {
      menuLabel.innerText = "Close";
      hamicon.setAttribute("aria-label", "close the menu");
      hamicon.setAttribute("aria-expanded", true);
      menuParentList.style.height = "calc(100vh - " + menuFromTop + "px)";
    } else {
      menuLabel.innerText = "Menu";
      hamicon.setAttribute("aria-label", "open the menu");
      hamicon.setAttribute("aria-expanded", false);
    }
  }
};

if (hamicon) {
  if (document.querySelector(".menu-with-cta .ham-menu")) {
    nav = document.querySelector(".main-navigation");
  }

  //nav = document.querySelector(".main-navigation");
  hamicon.style.display = "block";
  hamicon.addEventListener("click", openMobileNav);
  hamicon.addEventListener("keydown", (e) => {
    if (e.keyCode == 13 || e.keyCode == 32) {
      openMobileNav();
    }
  });
}

//Submenu Arrow Icon
var arrowchevron = document.createElement("div");
arrowchevron.classList.add("arrow-down");
arrowchevron.setAttribute("tabindex", 0);
arrowchevron.setAttribute("role", "button");

// let parentMenuarrow = document.querySelectorAll(".menu-item-has-children > a .arrow-down");
// let allparentMenuarrow = Array.prototype.slice.call(parentMenuarrow);
// allparentMenuarrow.forEach((menu) => {
//     let parentName = menu.textContent;
//     menu.setAttribute("aria-haspopup", true);
//     menu.setAttribute("aria-expanded", false);
//     menu.onclick = (event) => {
//         event.preventDefault();
//     };
//     menu.appendChild(arrowchevron.cloneNode(true));
//     let arrow = menu.children[0];
//     arrow.setAttribute("aria-label", "Open " + parentName + " Submenu");
// });

let parentMenu = document.querySelectorAll(".menu-item-has-children > a");
let allparentMenu = Array.prototype.slice.call(parentMenu);
allparentMenu.forEach((menu) => {
  let parentName = menu.textContent;
  // menu.setAttribute("aria-haspopup", true);
  // menu.setAttribute("aria-expanded", false);
  // menu.onclick = (event) => {
  //     event.preventDefault();
  // };
  menu.appendChild(arrowchevron.cloneNode(true));
  let arrow = menu.children[0];
  arrow.setAttribute("aria-label", "Open " + parentName + " Submenu");
});

// three level menu js start

//rotate 2nd level menu to left
let elementArrow = document.querySelectorAll(
  ".three-level-menu-container ul li ul li a .arrow-down"
);
elementArrow.forEach((arrowthirdlevel) => {
  arrowthirdlevel.classList.add("rotate-left");
});

// Remove no-js class from html
document.documentElement.classList.remove("no-js");

//interact with no sub menu -> working
let li_with_no_submenu = document.querySelectorAll(
  "li.menu-item:not(.menu-item-has-children)"
);
li_with_no_submenu.forEach((list_text) => {
  list_text.addEventListener("click", function (e) {
    let linkATag = list_text.querySelector("a").getAttribute("href");
    window.location.href = linkATag;
  });
});

// When interacting with a li that has a sub menu
//for opening menu and setting values of a and ul tag
let openSubmenuTask = (childUl, childA) => {
  
  childUl.classList.remove("js-hideElement");
  childUl.classList.add("js-showElement");
  let div = childA.querySelector("div");
  if(div){
    div.setAttribute("aria-label", "close the menu");
    div.setAttribute("aria-expanded", true);
  }
  
  childA.querySelector(".arrow-down").classList.add("rotate");
  //childA.setAttribute("aria-expanded", true);
  childA.classList.add("js-openSubMenu");
};

//for closing menu and setting values of a and ul tag
let closeSubmeutask = (childUl, childA) => {
  childUl.classList.remove("js-showElement");
  childUl.classList.add("js-hideElement");
  let div = childA.querySelector("div");
  if(div){
    div.setAttribute("aria-label", "open the menu");
    div.setAttribute("aria-expanded", false);
  }
  childA.querySelector(".arrow-down").classList.remove("rotate");
  //childA.setAttribute("aria-expanded", false);
  childA.classList.remove("js-openSubMenu");
};
(function () {
  if ($(window).width() < 960) {
    return false;
  }
  let liWithChildhren = document.querySelectorAll("li.menu-item-has-children");
  if (!liWithChildhren) {
    return false;
  }
  liWithChildhren.forEach((liwithchild) => {
    //mouseover function
    liwithchild.addEventListener("mouseover", function () {
      let ul = liwithchild.querySelector("ul");
      let atag = liwithchild.querySelector("a");
      openSubmenuTask(ul, atag);
    });

    //mouseleave function
    liwithchild.addEventListener("mouseleave", function () {
      let ul = liwithchild.querySelector("ul");
      let atag = liwithchild.querySelector("a");
      closeSubmeutask(ul, atag);
    });
  });
})();

let lidropdownarrow = document.querySelector(
  ".three-level-menu-container ul li.menu-item-has-children a"
);
let lidropdownarrowdata = document.querySelector(
  ".three-level-menu-container ul li.menu-item-has-children"
);
if (lidropdownarrow) {
  lidropdownarrow.addEventListener("click", function (e) {
    // e.preventDefault();
    if (e.target.classList.contains("arrow-down")) {
      e.preventDefault();
      // console.log(lidropdownarrowdata);
      let ul = lidropdownarrowdata.querySelector("ul");
      let atag = lidropdownarrowdata.querySelector("a");
      if (atag.classList.contains("js-openSubMenu")) {
        closeSubmeutask(ul, atag);
      } else {
        openSubmenuTask(ul, atag);
      }
    }
  });

  lidropdownarrow.addEventListener("keydown", function (event) {
    if (event.keyCode == 13) {
      // enter is pressed here
      // tab is pressed
      if (event.target.classList.contains("arrow-down")) {
        console.log("tab pressed");
        event.preventDefault();
        // console.log(lidropdownarrowdata);
        let ul = lidropdownarrowdata.querySelector("ul");
        let atag = lidropdownarrowdata.querySelector("a");
        if (atag.classList.contains("js-openSubMenu")) {
          closeSubmeutask(ul, atag);
        } else {
          openSubmenuTask(ul, atag);
        }
      }
    } else if (event.key === "Tab") {
    } else if (event.shiftKey && event.key === "Tab") {
      // shfft tab is pressed
    }
  });
}

//second level closing menu on focus out
let lastChildofUl = document.querySelectorAll(
  ".three-level-menu-container ul li ul li:last-child"
);
lastChildofUl.forEach((getLastChild) => {
  getLastChild.addEventListener("keydown", function (e) {
    var getUl = getLastChild.parentElement;
    var getATag = getUl.previousElementSibling;
    var menukeyCode = e.keyCode || e.which;
    var menushiftCode = e.shiftKey;
    if (menushiftCode == false && menukeyCode == 9) {
      if (
        getLastChild.querySelector("a").classList.contains("js-openSubMenu")
      ) {
      } else {
        closeSubmeutask(getUl, getATag);
      }
    }
  });
});

//for shift tab
let firstChildofUl = document.querySelectorAll(
  ".three-level-menu-container ul li ul li:first-child"
);
firstChildofUl.forEach((getFirstChild) => {
  getFirstChild.addEventListener("keydown", function (e) {
    if (e.target.parentElement == getFirstChild) {
      var getUl = getFirstChild.parentElement;
      var getATag = getUl.previousElementSibling;
      var menukeyCode = e.keyCode || e.which;
      var menushiftCode = e.shiftKey;
      if (menushiftCode == true && menukeyCode == 9) {
        closeSubmeutask(getUl, getATag);
      }
    }
  });
});

//for triggerin the close icon after focusing out the menu -> working
let mainUlContainer = document.querySelector(".three-level-menu-container");
mainUlContainer.addEventListener("focusout", function (e) {
  setTimeout(function () {
    var focus_ele = document.activeElement;
    if (
      !(
        focus_ele.classList.contains("three-level-menu-container") ||
        mainUlContainer.contains(document.activeElement)
      )
    ) {
      document.querySelector(".hamicon").focus();
    }
  }, 0);
});

if (hamicon) {
  hamicon.addEventListener("click", function (e) {
    let mobile_nav = document.querySelector(".only-mobile-menu");
    // mobile_nav.classList.add('active');
    // mobile_nav.style.animation = "fadeIn 1s ease-in";
    mobile_nav.classList.toggle("active");
  });

  hamicon.addEventListener("keydown", function (event) {
    let mobile_nav = document.querySelector(".only-mobile-menu");
    mobile_nav.classList.add("active");
  });
}

// Start Article Menu
(function () {
  let all_headings = document.querySelectorAll(".entry-content h2");
  if (all_headings.length > 0) {
    // console.log('if');
    let inthisarticles = document.querySelector(
      ".inthisarticle-wrapper .right-content"
    );
    for (let i = 0; i < all_headings.length; i++) {
      let uid = generate_unique_id();
      all_headings[i].setAttribute("id", uid);
      if (inthisarticles) {
        inthisarticles.innerHTML +=
          '<a href="#' + uid + '">' + all_headings[i].innerHTML + "</a>";
      }
    }
  } else {
    let ptag = document.querySelector(".inthisarticle-wrapper .left-content p");
    if (ptag) {
      ptag.style.display =
        "none";
      ptag.classList.add("rm_pseudocode");
    }
  }
})();
// End Article Menu

// Start Generate uniqueId Function
function generate_unique_id() {
  let s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
}
// End Generate uniqueId Function

// mobile menu onclick event to prevent what we do like menu arrow redirect
(function () {
  // run only if window is smaller then 960px
  if ($(window).width() > 960) {
    return false;
  }
  let allmenuitems = document.querySelectorAll(
    ".menu-main-menu-container .menu-item-has-children>a"
  );
  
  if (!allmenuitems) {
    return false;
  }
  for (let i = 0; i < allmenuitems.length; i++) {
    allmenuitems[i].setAttribute("aria-haspopup", true);
    allmenuitems[i].setAttribute("aria-expanded", false);
    allmenuitems[i].onclick = function (e) {
      if (
        e.target.classList.contains("arrow-down") &&
        e.target.classList.contains("rotate")
      ) {
        e.preventDefault();
        closeSubmeutask(
          allmenuitems[i].parentNode.querySelector("ul"),
          allmenuitems[i]
        );
      } else if (
        e.target.classList.contains("arrow-down") &&
        !e.target.classList.contains("rotate")
      ) {
        e.preventDefault();
        openSubmenuTask(
          allmenuitems[i].parentNode.querySelector("ul"),
          allmenuitems[i]
        );
      }
    };
  }
})();
